import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e311b37"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "janela-chat",
  role: "dialog",
  "aria-label": "Conversar com a LimaTec"
}
const _hoisted_2 = { class: "cabecalho-chat" }
const _hoisted_3 = { class: "avatar-chat" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titulo-chat" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "nome-chat" }, " LimaTec "),
  /*#__PURE__*/_createElementVNode("span", { class: "status-chat" }, " online ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "19",
  height: "19",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "corpo-chat" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "data-chat" }, " Hoje ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aviso-wa balao-0" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    viewBox: "0 0 24 24",
    width: "12",
    height: "12",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12 2a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7a5 5 0 0 0-5-5zm-3 8V7a3 3 0 1 1 6 0v3H9z" })
  ]),
  /*#__PURE__*/_createTextVNode(" Ao enviar, você continua a conversa no WhatsApp da LimaTec. ")
], -1))
const _hoisted_10 = { class: "balao-recebido balao-1" }
const _hoisted_11 = { class: "hora-balao" }
const _hoisted_12 = { class: "atalhos-chat balao-2" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 24 24",
  width: "22",
  height: "22",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M3.4 20.4l17.45-7.48a1 1 0 0 0 0-1.84L3.4 3.6a.993.993 0 0 0-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z" })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = ["title", "aria-label"]
const _hoisted_17 = {
  key: 0,
  viewBox: "0 0 32 32",
  width: "32",
  height: "32",
  fill: "#FFFFFF",
  "aria-hidden": "true"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M16 3C9.1 3 3.5 8.6 3.5 15.5c0 2.2.58 4.35 1.68 6.25L3.5 28.5l6.93-1.62a12.46 12.46 0 0 0 5.57 1.37c6.9 0 12.5-5.6 12.5-12.5S22.9 3 16 3zm0 22.75c-1.86 0-3.68-.5-5.27-1.44l-.38-.22-3.91.91.95-3.8-.25-.4a10.1 10.1 0 0 1-1.54-5.4C5.6 9.84 10.26 5.25 16 5.25S26.4 9.84 26.4 15.5 21.74 25.75 16 25.75zm5.7-7.66c-.31-.16-1.85-.91-2.13-1.02-.29-.1-.5-.15-.7.16-.21.31-.81 1.02-1 1.23-.18.2-.36.23-.67.08-.31-.16-1.32-.49-2.5-1.55a9.4 9.4 0 0 1-1.74-2.16c-.18-.31-.02-.48.14-.64.14-.14.31-.36.47-.54.15-.19.2-.32.31-.53.1-.2.05-.39-.03-.55-.08-.16-.7-1.69-.96-2.31-.25-.61-.51-.53-.7-.54h-.6c-.2 0-.54.08-.82.39-.28.31-1.08 1.05-1.08 2.57s1.1 2.98 1.26 3.19c.15.2 2.17 3.32 5.26 4.65.74.32 1.31.51 1.76.65.74.24 1.41.2 1.94.12.6-.09 1.85-.75 2.11-1.48.26-.73.26-1.36.18-1.49-.08-.13-.28-.2-.6-.36z" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  viewBox: "0 0 24 24",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "#FFFFFF",
  "stroke-width": "2.2",
  "stroke-linecap": "round",
  "aria-hidden": "true"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M6 6l12 12M18 6L6 18" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoLimaTec = _resolveComponent("LogoLimaTec")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "chat" }, {
      default: _withCtx(() => [
        (_ctx.aberto)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_LogoLimaTec, {
                    Altura: "30px",
                    class: "logo-chat"
                  })
                ]),
                _hoisted_4,
                _createElementVNode("button", {
                  class: "fechar-chat",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.aberto = false)),
                  "aria-label": "Fechar chat"
                }, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(" Olá! 👋 Como podemos ajudar? "),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.hora), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "atalho",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.enviarPronta('Preciso de um eletricista!')))
                  }, " Preciso de um eletricista "),
                  _createElementVNode("button", {
                    class: "atalho",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enviarPronta('Olá, gostaria de fazer um orçamento')))
                  }, " Quero um orçamento "),
                  _createElementVNode("button", {
                    class: "atalho",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.enviarPronta('Olá, gostaria de saber mais sobre Energia Solar')))
                  }, " Energia solar ")
                ])
              ]),
              _createElementVNode("form", {
                class: "rodape-chat",
                onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.enviar()), ["prevent"]))
              }, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.mensagem) = $event)),
                  ref: "campoMensagem",
                  class: "campo-chat",
                  type: "text",
                  placeholder: "Mensagem",
                  "aria-label": "Sua mensagem"
                }, null, 512), [
                  [_vModelText, _ctx.mensagem]
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  class: "botao-enviar",
                  disabled: !_ctx.mensagem.trim(),
                  "aria-label": "Enviar pelo WhatsApp"
                }, _hoisted_15, 8, _hoisted_13)
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("button", {
      class: "button-whatsapp",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.alternar())),
      title: _ctx.TextoWhatsApp,
      "aria-label": _ctx.aberto ? 'Fechar chat' : 'Conversar no WhatsApp'
    }, [
      (!_ctx.aberto)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_19))
        : (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
    ], 8, _hoisted_16)
  ], 64))
}